/**
 * 批量订单导入 API 服务
 */

const API_BASE = '/api';

export interface PreviewRow {
  rowIndex: number;
  name: string;
  phone: string;
  email: string;
  vipType: '3year' | '2year';
  vipLabel: string;
  tokenQuota: number;
  durationDays: number;
  registered: boolean;
  userId: string | null;
  username: string | null;
}

export interface PreviewStats {
  total: number;
  registered: number;
  unregistered: number;
  threeYear: number;
  twoYear: number;
}

export interface PreviewResult {
  rows: PreviewRow[];
  stats: PreviewStats;
}

export const batchOrderApi = {
  /**
   * 上传 Excel 并获取预览数据
   */
  async preview(file: File, accessToken: string): Promise<PreviewResult> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE}/admin/batch-order/preview`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
      body: formData,
    });

    const result = await response.json();
    if (!result.success) {
      throw new Error(result.error || '预览失败');
    }
    return result.data;
  },

  /**
   * 执行批量处理并下载结果 Excel
   */
  async execute(rows: PreviewRow[], accessToken: string): Promise<{
    blob: Blob;
    successCount: number;
    skipCount: number;
    failCount: number;
  }> {
    const response = await fetch(`${API_BASE}/admin/batch-order/execute`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ rows }),
    });

    if (!response.ok) {
      let errorMsg = '处理失败';
      try {
        const errJson = await response.json();
        errorMsg = errJson.error || errorMsg;
      } catch {
        // 非 JSON 响应
      }
      throw new Error(errorMsg);
    }

    const blob = await response.blob();
    return {
      blob,
      successCount: Number(response.headers.get('X-Batch-Success') || 0),
      skipCount: Number(response.headers.get('X-Batch-Skip') || 0),
      failCount: Number(response.headers.get('X-Batch-Fail') || 0),
    };
  },
};
